module.exports = __webpack_public_path__ + "img/IMG_1627_BlackMatted.65f641ec.jpg";